import React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { IoIosArrowBack } from "react-icons/io";

import { FaLink } from "react-icons/fa6";

import { TransactionRyder } from "./transactionRyder";
import { useNavigate } from "react-router-dom";

const columns = [
  { id: "sno", label: "S NO", minWidth: 100, align: "center" },
  { id: "invoice", label: "INVOICE NO/DATE", minWidth: 170, align: "center" },
  { id: "orderid", label: "ORDER ID", minWidth: 100, align: "center" },
  {
    id: "invoiceamount",
    label: "INVOICE AMOUNT",
    minWidth: 170,
    align: "center",
  },
  {
    id: "conventiencefee",
    label: "CONVENIENCE FEE",
    minWidth: 170,
    align: "center",
  },
  { id: "gst1", label: "GST(18%)", minWidth: 130, align: "center" },
  { id: "ryderfee", label: "RYDER FEE", minWidth: 170, align: "center" },
  { id: "gst2", label: "GST(18%)", minWidth: 130, align: "center" },
  {
    id: "totalamountpaid",
    label: "TOTAL AMOUNT PAID",
    minWidth: 170,
    align: "center",
  },
];

function createData(
  sno,
  invoice,
  orderid,
  invoiceamount,
  conventiencefee,
  gst1,
  ryderfee,
  gst2,
  totalamountpaid
) {
  return {
    sno,
    invoice,
    orderid,
    invoiceamount,
    conventiencefee,
    gst1,
    ryderfee,
    gst2,
    totalamountpaid,
  };
}

const rows = [
  createData(
    1,
    "000276-2/05/2025",
    "GK1233",
    "10,000.00",
    50,
    "XXXXXX",
    "200",
    "XXXXX",
    "XXXXXXXXXX"
  ),
];

export function RyderInvoice() {
  const navigate=useNavigate();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <div className="invoice-container">
      <div className="invoice-subcontainer">
        <IoIosArrowBack
          style={{ cursor: "pointer" }}
          onClick={()=>navigate("/transaction-ryder")}
        
        />
        
      </div>
      <div className="text-invoice"><span  >INVOICE</span></div>
      <div className="invoice-content">
        <div className="fromaddress-container">
          <ul className="fromaddress-list">
            <li>GO MAK Connect Pvt Ltd</li>
            <li># 8-13-25 </li>
            <li>Kattavari Street, Wynchipet, </li>
            <li>Vijayawada – 520001 A.P</li>
            <li>Website:www.gomak.in</li>
            <li>Mail id: contact@gomak.in</li>
            <li>GSTIN: XXXXX   </li>
            <li>Ph: XXXX  </li>
          </ul>
        </div>
        <div className="invoicedetails-container">
          <ul className="details-list">
            <li> Invoice Date: xx/xx/2025</li>
            <li> Invoice Number: G-2425-1307292</li>
          </ul>
        </div>
        <div className="toaddress-container">
          <ul className="toaddress-list">
            <li>   To</li>
            <li>Retailer Name</li>
            <li>Retailer Address, </li>
            <li>Address</li>
            <li>Address</li>
            <li>GSTIN: xxxxxxx</li>
            <li>State/UT Code: 37   </li>
          </ul>
        </div>
      </div>
      <div className="table-content">
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index}
                      sx={{
                        backgroundColor: index % 2 === 1 ? "#E7F0F9" : "white",
                      }}
                    >
                      {columns.map((column) => {
                        const value = row[column.id];

                        return (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            className={`${column.id}-Wholesalercolumn tableCelldata`}
                            sx={{
                              color:
                                column.id === "status"
                                  ? value === "Closed"
                                    ? "green"
                                    : "red"
                                  : "inherit",
                            }}
                          >
                            {column.id === "invoicesummary" ? (
                              <div
                                style={{ cursor: "pointer" }}
                               
                              >
                                <span
                                  className="me-1"
                                  style={{ color: "#4184D1" }}
                                >
                                  <FaLink />
                                </span>
                                Link
                              </div>
                            ) : (
                              value
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          {/* <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        /> */}
        </Paper>
      </div>
      <div className="amount-container">
        <div className="amount-word"> In Words:  Rupees Two Hundred and Twenty Five Only</div>
        <div className="amount-total"><span className="me-4">TOTAL :</span><span>XXXXXXXXX</span></div>
      </div>
      <div className="company-details">
        <div className="company-title">For GO MAK Connect Pvt Ltd.</div>
        <div className="company-sign">Authorized Signatory</div>

      </div>
    </div>
  );
}
